(function () {
  function initializeDFBBedConfigurator() {
  const root = document.getElementById('dfb-bed-configurator');
  if (!root || root.dataset.dfbInitialized) return;
  
  const productScope = root.closest('.shopify-section') || document;

  const variantRoot =
    productScope.querySelector('variant-picker[data-template-product-match="true"]') ||
    document.querySelector('variant-picker[data-template-product-match="true"]') ||
    productScope.querySelector('variant-picker') ||
    document.querySelector('[data-variant-picker]');

  const panels = {
    size: document.getElementById('dfb-size-panel'),
    colour: document.getElementById('dfb-colour-panel'),
    storage: document.getElementById('dfb-storage-panel'),
    mattress: document.getElementById('dfb-mattress-panel'),
    headboard: document.getElementById('dfb-headboard-panel')
  };

  if (
  !panels.size ||
  !panels.colour ||
  !panels.mattress ||
  !panels.headboard
) {
  return;
}

root.dataset.dfbInitialized = 'true';
  const state = {
    size: '',
    colour: '',
    basePrice: 0,
    baseComparePrice: 0,
    baseProduct: null,
    baseVariant: null,
    sizePosition: 0,
    colourPosition: 0,
    headboardPosition: 0,
    optionValues: [],
    ready: false,
    mattresses: null,
    headboards: null,
    mattress: null,
    headboard: null,
    divanHeadboard: '',
    storage: {
      id: null,
      title: 'No Drawer',
      price: 0,
      image: 'https://cdn.shopify.com/s/files/1/0762/0575/2469/files/0Drawer_9c00ed26-40d4-4228-a205-0ca586bac520.png?v=1790832872'
    },

    // Optional delivery/service add-ons.
    // These are updated by the Optional Cards block via the
    // dfb:service-updated browser event.
    services: {
      build: {
        selected: false,
        price: 39.99
      },
      recycle: {
        selected: false,
        price: 59.99
      }
    }
  };

  let cartBusy = false;

  const HEADBOARD_ORDER = [
    'Perth Luxury 26" Strutted Headboard',
    'Geneva Luxury 26" Strutted Headboard',
    'Berlin Luxury 26" Strutted Headboard',
    'Berlin Deluxe 54" Floor Standing Headboard',
    'Chesterfield Deluxe 54" Floor Standing Headboard'
  ];

  const sizeMeta = [
    {
      key: 'small_single',
      label: "2'6 Small Single",
      dimensions: '75cm x 190cm',
      icon: root.dataset.sizeIconSmallSingle
    },
    {
      key: 'single',
      label: "3'0 Single",
      dimensions: '90cm x 190cm',
      icon: root.dataset.sizeIconSingle
    },
    {
      key: 'small_double',
      label: "4'0 Small Double",
      dimensions: '120cm x 190cm',
      icon: root.dataset.sizeIconSmallDouble
    },
    {
      key: 'double',
      label: "4'6 Double",
      dimensions: '135cm x 190cm',
      icon: root.dataset.sizeIconDouble
    },
    {
      key: 'king',
      label: "5'0 King Size",
      dimensions: '150cm x 200cm',
      icon: root.dataset.sizeIconKing
    },
    {
      key: 'super_king',
      label: "6'0 Super King",
      dimensions: '180cm x 200cm',
      icon: root.dataset.sizeIconSuperKing
    }
  ];

  function clean(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/["“”]/g, '')
      .replace(/[-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function apiPrice(value) {
    return parseFloat(value || 0) || 0;
  }

  function money(value) {
    return '£' + Number(value || 0).toFixed(2);
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function sizeKey(value) {
    const s = clean(value);
    const feet = String(value || '').toLowerCase().replace(/[’′]/g, "'");
    if (/2\s*'\s*6/.test(feet)) return 'small_single';
    if (/4\s*'\s*6/.test(feet)) return 'double';
    if (/3\s*'/.test(feet)) return 'single';
    if (/4\s*'/.test(feet)) return 'small_double';
    if (/5\s*'/.test(feet)) return 'king';
    if (/6\s*'/.test(feet)) return 'super_king';

    if (
      s.includes('2ft6') ||
      s.includes('2 ft 6') ||
      s.includes('75cm')
    ) {
      return 'small_single';
    }

    if (
      s.includes('4ft6') ||
      s.includes('4 ft 6') ||
      s.includes('135cm')
    ) {
      return 'double';
    }

    if (
      s.includes('4ft') ||
      s.includes('4 ft') ||
      s.includes('120cm')
    ) {
      return 'small_double';
    }

    if (
      s.includes('3ft') ||
      s.includes('3 ft') ||
      s.includes('90cm')
    ) {
      return 'single';
    }

    if (
      s.includes('5ft') ||
      s.includes('5 ft') ||
      s.includes('150cm')
    ) {
      return 'king';
    }

    if (
      s.includes('6ft') ||
      s.includes('6 ft') ||
      s.includes('180cm')
    ) {
      return 'super_king';
    }

    if (s.includes('super king')) return 'super_king';
    if (s.includes('small single')) return 'small_single';
    if (s.includes('small double')) return 'small_double';
    if (s.includes('king')) return 'king';
    if (s.includes('double')) return 'double';
    if (s.includes('single')) return 'single';

    return '';
  }

  function metaFor(value) {
    return (
      sizeMeta.find(function (item) {
        return item.key === sizeKey(value);
      }) || null
    );
  }

  function colourKey(value) {
    const s = clean(value);

    const colours = [
      'cream',
      'mink',
      'pink',
      'silver',
      'gold',
      'charcoal',
      'green',
      'blue',
      'black'
    ];

    return (
      colours.find(function (colour) {
        return s.includes(colour);
      }) || ''
    );
  }

  function fabricKey(value) {
    const s = clean(value);

    if (s.includes('naples')) return 'naples';

    if (
      s.includes('plush velvet') ||
      s.includes('plush')
    ) {
      return 'plush';
    }

    return '';
  }

  // Product JSON is the source of truth. The optional native picker is only hidden.
  function baseOptionValues(position) {
    if (!state.baseProduct || !position) return [];

    return Array.from(new Set(
      state.baseProduct.variants.map(function (variant) {
        return variantOption(variant, position);
      }).filter(Boolean)
    ));
  }

  function productSizeOptions() {
    return baseOptionValues(state.sizePosition)
      .filter(function (value) { return !!sizeKey(value); })
      .sort(function (a, b) {
        return sizeMeta.findIndex(function (item) { return item.key === sizeKey(a); }) -
          sizeMeta.findIndex(function (item) { return item.key === sizeKey(b); });
      })
      .map(function (value) {
        return {
          value: value,
          label: value,
          selected: value === state.size
        };
      });
  }

  function productColourOptions() {
    return baseOptionValues(state.colourPosition).map(function (value) {
      return { value: value };
    });
  }

  function selectedSize() {
    return state.size;
  }

  function baseOptionName(position) {
    if (!state.baseProduct || !position) return '';

    const option = state.baseProduct.options[position - 1];

    return option && typeof option === 'object'
      ? String(option.name || '')
      : String(option || '');
  }

  function updateBrowserVariantUrl() {
    if (!state.baseVariant) return;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(state.baseVariant.id));

      if (url.href !== window.location.href) {
        history.replaceState(
          history.state,
          '',
          url.toString()
        );
      }
    } catch (error) {
      console.warn('DFB variant URL could not be updated:', error);
    }
  }

  function syncNativeVariantPicker(changedPosition) {
    if (
      !variantRoot ||
      !state.baseProduct ||
      !state.baseVariant
    ) {
      updateBrowserVariantUrl();
      return false;
    }

    let changedControl = null;

    state.baseProduct.options.forEach(function (option, index) {
      const position = index + 1;
      const optionName = baseOptionName(position);
      const wantedValue = variantOption(state.baseVariant, position);

      if (!optionName || !wantedValue) return;

      const expectedName = 'options[' + optionName + ']';

      const controls = Array.from(
        variantRoot.querySelectorAll(
          'select, input[type="radio"]'
        )
      ).filter(function (control) {
        return control.name === expectedName;
      });

      controls.forEach(function (control) {
        if (control.tagName === 'SELECT') {
          control.value = wantedValue;

          Array.from(control.options).forEach(function (item) {
            item.toggleAttribute(
              'selected',
              item.value === wantedValue
            );
          });

          if (position === changedPosition) {
            changedControl = control;
          }

          return;
        }

        const checked =
          control.value === wantedValue;

        control.checked = checked;
        control.toggleAttribute(
          'checked',
          checked
        );
        control.dataset.currentChecked =
          String(checked);

        if (
          checked &&
          position === changedPosition
        ) {
          changedControl = control;
        }
      });
    });

    updateBrowserVariantUrl();

    if (!changedControl) {
      console.warn(
        'DFB Configurator: matching native variant control was not found for position',
        changedPosition
      );
      return false;
    }

    changedControl.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );

    return true;
  }

  function refreshAfterNativeVariantChange() {
    setTimeout(function () {
      if (!root.isConnected) return;

      writeBaseVariant();
      updateBrowserVariantUrl();
      updateTotal();
      updateConfiguredMedia();
      enableExistingStickyPrice();
    }, 450);
  }

  const knownBedForms = new WeakSet();

  function mainBedForms() {
    const containing = root.closest('form[action*="/cart/add"]');
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .filter(function (form) {
        return !form.matches('.addon-form, [data-dfb-addon-form]') &&
          !form.closest('.addon-wrapper, [data-dfb-addons], product-recommendations, quick-add-modal, dialog, .quick-add');
      });

    const ids = new Set((state.baseProduct?.variants || []).map(function (variant) {
      return String(variant.id);
    }));

    return forms.filter(function (form) {
      const fields = Array.from(form.elements).filter(function (field) {
        return field.name === 'id';
      });
      const matches = form === containing || knownBedForms.has(form) ||
        fields.some(function (field) { return ids.has(String(field.value)); }) ||
        (state.baseProduct?.id != null && String(form.dataset.productId) === String(state.baseProduct.id)) ||
        (productScope !== document && productScope.contains(form) && !fields.length);
      if (matches) knownBedForms.add(form);
      return matches;
    });
  }

  function mainBedForm() {
    return mainBedForms()[0] || null;
  }

  function writeBaseVariant() {
    mainBedForms().forEach(function (form) {

      let fields = Array.from(form.elements).filter(function (field) {
        return field.name === 'id';
      });

      if (!fields.length) {
        const field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'id';
        form.appendChild(field);
        fields = [field];
      }

      fields.forEach(function (field) {
        const id = state.baseVariant ? String(state.baseVariant.id) : '';
        if (field.tagName === 'SELECT' && id && !Array.from(field.options).some(function (option) {
          return option.value === id;
        })) {
          field.add(new Option(id, id));
        }
        field.value = id;
        field.disabled = !state.baseVariant;
      });
    });
  }

  function resolveBaseVariant() {
    if (!state.baseProduct) return null;
    state.optionValues[state.sizePosition - 1] = state.size;
    if (state.colourPosition) state.optionValues[state.colourPosition - 1] = state.colour;
    if (state.headboardPosition && state.divanHeadboard) {
      state.optionValues[state.headboardPosition - 1] = state.divanHeadboard;
    }

    const matches = state.baseProduct.variants.filter(function (variant) {
      return state.optionValues.every(function (value, index) {
        return variantOption(variant, index + 1) === value;
      });
    });

    state.baseVariant = matches.find(function (variant) {
      return variant.available;
    }) || matches[0] || null;

    writeBaseVariant();
    updateBrowserVariantUrl();

    return state.baseVariant;
  }

  let mediaSelectionRequest = 0;

  async function updateConfiguredMedia() {
    const request = ++mediaSelectionRequest;
    const variant = state.baseVariant;
    if (!variant || !root.isConnected) return;

    updateBrowserVariantUrl();
    // Mirror resolved JSON values to optional theme controls for image apps that
    // read them later. These controls never supply the configurator's state.
    const picker = variantRoot;
    if (picker) {
      state.baseProduct.options.forEach(function (option, index) {
        const name = 'options[' + (option.name || option) + ']';
        const value = variantOption(variant, index + 1);
        Array.from(picker.querySelectorAll('select, input[type="radio"]')).forEach(function (input) {
          if (input.name !== name) return;
          if (input.tagName === 'SELECT') {
            input.value = value;
            Array.from(input.options).forEach(function (item) {
              item.toggleAttribute('selected', item.value === value);
            });
          } else {
            input.checked = input.value === value;
            input.toggleAttribute('checked', input.checked);
            input.dataset.currentChecked = String(input.checked);
          }
        });
      });
    }
    // Rubik owns variant-image filtering on this store. Its documented-in-page
    // listener accepts the resolved variant ID directly, without picker discovery.
    document.dispatchEvent(new CustomEvent('rubik-variant-id-changed', {
      detail: { variantId: variant.id, initialLoad: false }
    }));
    const hasImage = function (item) {
      return item.featured_media?.id || item.featured_image?.src;
    };
    const imageVariant = hasImage(variant) ? variant :
      (state.colourPosition ? state.baseProduct.variants.find(function (item) {
        return variantOption(item, state.colourPosition) === state.colour && hasImage(item);
      }) : null);
    if (!imageVariant) return;

    // Custom Liquid can be in a separate section from the product gallery.
    const matchingPrice = Array.from(document.querySelectorAll('product-price[data-product-id]')).find(function (price) {
      return String(price.dataset.productId) === String(state.baseProduct.id) &&
        !price.closest('product-recommendations, quick-add-modal, dialog');
    });
    const galleryScope = matchingPrice?.closest('.shopify-section') || productScope;
    const gallery = galleryScope.querySelector('media-gallery');
    const slideshow = gallery?.querySelector('slideshow-component');
    if (!slideshow) return;
    const mediaId = String(imageVariant.featured_media?.id || '');
    const imageURL = imageVariant.featured_image?.src || imageVariant.featured_media?.preview_image?.src;
    // Shopify can serve the same image on the shop domain or cdn.shopify.com.
    const imageName = function (value) {
      if (!value) return '';
      try { return new URL(value, location.href).pathname.split('/').pop(); }
      catch (error) { return ''; }
    };
    const wantedImage = imageName(imageURL);
    const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    const target = slides.find(function (slide) {
      return mediaId && Array.from(slide.querySelectorAll('[data-media-id]')).some(function (media) {
        return media.dataset.mediaId === mediaId;
      });
    }) || slides.find(function (slide) {
      return wantedImage && Array.from(slide.querySelectorAll('img')).some(function (image) {
        return imageName(image.currentSrc || image.src) === wantedImage;
      });
    });
    if (!target) return;

    try {
      // Gallery modules may finish loading after the product JSON request.
      await customElements.whenDefined('slideshow-component');
      await new Promise(function (resolve) { requestAnimationFrame(resolve); });
      if (request !== mediaSelectionRequest || !root.isConnected || !slideshow.isConnected) return;
      if (typeof slideshow.select !== 'function') return;
      const slideId = target.getAttribute('slide-id');
      const visibleSlides = slideshow.slides || slides.filter(function (slide) { return !slide.hidden; });
      const index = Array.from(visibleSlides).indexOf(target);
      if (slideId || index >= 0) {
        // Use Horizon's gallery API so thumbnails, arrows, zoom and mobile stay in sync.
        await slideshow.select(slideId ? { id: slideId } : index, undefined, { animate: false });
      }
    } catch (error) {
      console.warn('DFB colour image could not be selected:', error);
    }
  }

  function updateBaseAvailability() {
    const available = state.ready && !!state.baseVariant?.available;
    mainBedForms().forEach(function (form) {
      if (!cartBusy) {
        Array.from(form.elements).filter(function (field) {
          return field.type === 'submit' || isBuyNowButton(field);
        }).forEach(function (button) {
          button.disabled = !available;
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
      }
    });

    let message = root.querySelector('.dfb-base-status');
    if (!message) {
      message = document.createElement('p');
      message.className = 'dfb-base-status dfb-config-message';
      message.setAttribute('role', 'status');
      root.appendChild(message);
    }
    message.hidden = available;
    message.textContent = !state.ready
      ? 'Loading bed options…'
      : state.baseVariant ? 'This size and colour are currently sold out.'
        : 'This size and colour combination is unavailable. Please choose another.';
  }

  function setConfiguredSize(value) {
    if (!state.ready || cartBusy || !baseOptionValues(state.sizePosition).includes(value)) return;

    state.size = value;

    resetStorageIfInvalid();
    resetAddedButtonState();
    resolveBaseVariant();

    syncNativeVariantPicker(
      state.sizePosition
    );

    updateConfiguredMedia();
    sync(true);

    // DIVAN:
    // If a headboard has already been chosen, changing the bed size
    // changes the matching Shopify headboard variant and therefore its
    // upgrade price. Refresh the headboard row immediately so the
    // displayed 54" upgrade always matches the newly selected size.
    if (isDivanConfigurator()) {
      updateHeadboardRow();

      if (
        panels.headboard &&
        !panels.headboard.hidden
      ) {
        renderHeadboards();
      }
    }

    refreshAfterNativeVariantChange();
  }

  function swatchData() {
    const rows =
      Array.from(
        document.querySelectorAll(
          '#dfb-colour-data ' +
          '.dfb-colour-data-item'
        )
      );

    const results = [];
    const seen = new Set();

    rows.forEach(function (item) {
      const value =
        item.dataset.value || '';

      if (!value) return;

      const unique =
        clean(value);

      if (seen.has(unique)) {
        return;
      }

      seen.add(unique);

      const visual =
        item.querySelector(
          '.dfb-colour-data-visual'
        );

      results.push({
        value: value,
        key: colourKey(value),
        fabric: fabricKey(value),

        image:
          visual
            ? visual.dataset.image || ''
            : '',

        color:
          visual
            ? visual.dataset.color || ''
            : '',

        initialSelected:
          item.dataset.selected ===
          'true'
      });
    });

    return results;
  }

  function findSwatch(value) {
    const wanted =
      clean(value);

    return (
      swatchData().find(
        function (item) {
          return (
            clean(item.value) ===
            wanted
          );
        }
      ) || null
    );
  }

  function selectedColour() {
    return state.colour;
  }

  async function setConfiguredColour(value) {
    if (!state.ready || cartBusy || !baseOptionValues(state.colourPosition).includes(value)) return;

    state.colour = value;

    resetAddedButtonState();
    resolveBaseVariant();

    syncNativeVariantPicker(
      state.colourPosition
    );

    await updateConfiguredMedia();
    sync(true);

    refreshAfterNativeVariantChange();
    scrollProductMediaToTop();
  }

  function paintSwatch(
    target,
    value
  ) {
    if (!target) return;

    const data =
      findSwatch(value);

    target.style.backgroundImage =
      'none';

    target.style.backgroundColor =
      '#eeeeee';

    if (!data) return;

    if (data.image) {
      target.style.backgroundImage =
        'url("' +
        data.image +
        '")';

      target.style.backgroundSize =
        'cover';

      target.style.backgroundPosition =
        'center';

      target.style.backgroundRepeat =
        'no-repeat';
    }

    if (data.color) {
      target.style.backgroundColor =
        data.color;
    }
  }

  const colourPreview =
    document.createElement('div');

  colourPreview.className =
    'dfb-colour-hover-preview';

  colourPreview.hidden =
    true;

  colourPreview.innerHTML = `
    <div
      class="dfb-colour-hover-preview-name"
    ></div>

    <div
      class="dfb-colour-hover-preview-image"
    ></div>
  `;

  document.body.appendChild(
    colourPreview
  );

  function showColourPreview(button) {
    if (window.innerWidth < 750) {
      return;
    }

    const value =
      button.dataset.value;

    const name =
      colourPreview.querySelector(
        '.dfb-colour-hover-preview-name'
      );

    const visual =
      colourPreview.querySelector(
        '.dfb-colour-hover-preview-image'
      );

    name.textContent =
      value;

    paintSwatch(
      visual,
      value
    );

    colourPreview.hidden =
      false;

    const rect =
      button.getBoundingClientRect();

    const width =
      250;

    const height =
      colourPreview.offsetHeight;

    let left =
      rect.left +
      rect.width / 2 -
      width / 2;

    let top =
      rect.top -
      height -
      14;

    if (top < 10) {
      top =
        rect.bottom + 14;
    }

    left =
      Math.max(
        10,
        Math.min(
          left,
          window.innerWidth -
          width -
          10
        )
      );

    colourPreview.style.left =
      left + 'px';

    colourPreview.style.top =
      top + 'px';
  }

  function hideColourPreview() {
    colourPreview.hidden =
      true;
  }

const STORAGE_OPTIONS = [
  {
    id: null,
    title: 'No Drawer',
    price: 0,
    image: 'https://cdn.shopify.com/s/files/1/0762/0575/2469/files/0Drawer_9c00ed26-40d4-4228-a205-0ca586bac520.png?v=1790832872'
  },
  {
    id: 47035008123029,
    title: '2 Drawer Same Side Left',
    price: 60,
    image: 'https://cdn.shopify.com/s/files/1/0762/0575/2469/files/2DrawLeft_d1cd5384-f8d6-4d85-a61c-b1bfa88dd391.png?v=1790832837'
  },
  {
    id: 47035008155797,
    title: '2 Drawer Same Side Right',
    price: 60,
    image: 'https://cdn.shopify.com/s/files/1/0762/0575/2469/files/2DrawRight_4a009891-7d4a-4205-80b7-e0742d1b6503.png?v=1790832902'
  },
  {
    id: 47035008090261,
    title: '2 Drawer Foot End',
    price: 50,
    image: 'https://cdn.shopify.com/s/files/1/0762/0575/2469/files/2DrawFoot_038b079a-1193-463e-81e6-7681c5b1a40a.png?v=1790832928'
  },
  {
    id: 47035008188565,
    title: '4 Drawer Storage',
    price: 100,
    image: 'https://cdn.shopify.com/s/files/1/0762/0575/2469/files/4Drawer_244e7e6a-3c64-4e2a-ab98-350716cdae40.png?v=1790832765'
  }
];

  function hasStorageConfigurator() {
    return !!panels.storage;
  }

  function storageOptionAllowed(option) {
    if (!option) return false;

    const key = sizeKey(state.size);

    if (key === 'small_single') {
      return option.id === null;
    }

    if (
      key === 'single' &&
      (
        option.id === 47035008090261 ||
        option.id === 47035008188565
      )
    ) {
      return false;
    }

    return true;
  }

  function updateStorageRow() {
    if (!hasStorageConfigurator()) return;

    const value =
      document.getElementById('dfb-storage-value');

    const icon =
      document.getElementById('dfb-selected-storage-icon');

    if (value) {
      value.textContent =
        sizeKey(state.size) === 'small_single'
          ? 'Not available for this size'
          : state.storage.title;
    }

    if (icon && state.storage.image) {
      icon.src = state.storage.image;
    }
  }

  function resetStorageIfInvalid() {
    if (!hasStorageConfigurator()) return;

    if (!storageOptionAllowed(state.storage)) {
      state.storage = STORAGE_OPTIONS[0];
    }

    updateStorageRow();
  }

  function setConfiguredStorage(option) {
    if (!hasStorageConfigurator() || cartBusy || !option) return;
    if (!storageOptionAllowed(option)) return;

    state.storage = option;

    resetAddedButtonState();
    updateStorageRow();
    updateTotal();
    renderStorage();

    closePanels(
      null,
      isMobile()
    );
  }

  function renderStorage() {
    if (!hasStorageConfigurator()) return;

    if (sizeKey(state.size) === 'small_single') {
      panels.storage.innerHTML = `
        <p class="dfb-storage-message">
          Drawers are not available for this size.
        </p>
      `;
      return;
    }

    const options =
      STORAGE_OPTIONS.filter(storageOptionAllowed);

    panels.storage.innerHTML = `
      <div class="dfb-storage-grid">
        ${
          options.map(function (option) {
            const selected =
              String(option.id || '') ===
              String(state.storage.id || '');

            return `
              <button
                type="button"
                class="dfb-storage-choice${selected ? ' is-selected' : ''}"
                data-storage-id="${option.id || ''}"
              >
                <img
                  src="${escapeHtml(option.image)}"
                  alt="${escapeHtml(option.title)}"
                >
                <strong>${escapeHtml(option.title)}</strong>
                <span>${option.price ? '+' + money(option.price) : 'Included'}</span>
              </button>
            `;
          }).join('')
        }
      </div>
    `;

    panels.storage
      .querySelectorAll('.dfb-storage-choice')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          const id =
            this.dataset.storageId
              ? Number(this.dataset.storageId)
              : null;

          const option =
            STORAGE_OPTIONS.find(function (item) {
              return String(item.id || '') === String(id || '');
            });

          setConfiguredStorage(option);
        });
      });
  }

  function updateSizeRow() {
    state.size =
      selectedSize();

    const meta =
      metaFor(state.size);

    const value =
      document.getElementById(
        'dfb-selected-size'
      );

    const icon =
      document.getElementById(
        'dfb-selected-size-icon'
      );

    if (value) {
      value.textContent =
        meta
          ? meta.label
          : state.size;
    }

    if (
      icon &&
      meta &&
      meta.icon
    ) {
      icon.src =
        meta.icon;
    }
  }

  function updateColourRow() {
    state.colour =
      selectedColour();

    const value =
      document.getElementById(
        'dfb-selected-colour'
      );

    const visual =
      document.querySelector(
        '#dfb-selected-colour-icon ' +
        '.dfb-current-colour-swatch'
      );

    if (value) {
      value.textContent =
        state.colour;
    }

    paintSwatch(
      visual,
      state.colour
    );
  }

  let cachedPriceHost = null;

  function priceHost() {
    if (cachedPriceHost?.isConnected) return cachedPriceHost;

    const hosts =
      Array.from(
        document.querySelectorAll(
          'product-price'
        )
      ).filter(function (host) {
        return !host.closest(
          'product-recommendations, quick-add-modal, dialog'
        );
      });

    const exact =
      state.baseProduct
        ? hosts.find(function (host) {
            return (
              host.dataset.productId &&
              String(host.dataset.productId) ===
              String(state.baseProduct.id)
            );
          })
        : null;

    const found =
      exact ||
      hosts.find(
        function (host) {
          return Array.from(
            host.querySelectorAll(
              'span,div'
            )
          ).some(
            function (element) {
              return (
                /^£\s?[\d,.]+$/.test(
                  element.textContent.trim()
                )
              );
            }
          );
        }
      ) ||
      null;

    if (found) {
      cachedPriceHost = found;
    }

    return found;
  }

  function enableExistingStickyPrice() {
    const host =
      priceHost();

    if (!host) return;

    host.classList.add(
      'dfb-existing-price-sticky'
    );
  }

  function stickyPriceHeight() {
    const host =
      priceHost();

    return host
      ? host.getBoundingClientRect().height
      : 45;
  }

  let mobileScrollTimer = null;

  function scrollConfiguratorToTop() {
    if (!isMobile()) return;

    clearTimeout(mobileScrollTimer);
    mobileScrollTimer = setTimeout(function () {
      enableExistingStickyPrice();

      const rootTop =
        root.getBoundingClientRect().top +
        window.pageYOffset;

      const destination =
        rootTop -
        stickyPriceHeight() -
        8;

      window.scrollTo({
        top: Math.max(
          destination,
          0
        ),
        behavior: 'smooth'
      });
    }, 80);
  }

  function scrollSectionToTop(name) {
    if (!isMobile()) return;

    const section =
      root.querySelector(
        '[data-dfb-section="' +
        name +
        '"]'
      );

    if (!section) return;

    clearTimeout(mobileScrollTimer);
    mobileScrollTimer = setTimeout(function () {
      enableExistingStickyPrice();

      const sectionTop =
        section
          .getBoundingClientRect()
          .top +
        window.pageYOffset;

      const destination =
        sectionTop -
        stickyPriceHeight() -
        8;

      window.scrollTo({
        top: Math.max(
          destination,
          0
        ),
        behavior: 'smooth'
      });
    }, 100);
  }

  function scrollProductMediaToTop() {
    if (!isMobile()) return;

    const matchingPrice = Array.from(
      document.querySelectorAll('product-price[data-product-id]')
    ).find(function (price) {
      return state.baseProduct &&
        String(price.dataset.productId) === String(state.baseProduct.id) &&
        !price.closest('product-recommendations, quick-add-modal, dialog');
    });

    const galleryScope = matchingPrice?.closest('.shopify-section') || productScope;
    const gallery = galleryScope.querySelector('media-gallery');
    if (!gallery) return;

    clearTimeout(mobileScrollTimer);
    mobileScrollTimer = setTimeout(function () {
      if (!root.isConnected || !gallery.isConnected) return;

      const galleryTop =
        gallery.getBoundingClientRect().top +
        window.pageYOffset;

      window.scrollTo({
        top: Math.max(galleryTop - 8, 0),
        behavior: 'smooth'
      });
    }, 80);
  }

  function closePanels(
    except,
    returnToTop
  ) {
    Object.keys(panels)
      .forEach(function (name) {
        if (name === except) {
          return;
        }

        if (!panels[name]) {
          return;
        }

        panels[name].hidden =
          true;

        root.querySelector(
          '[data-dfb-trigger="' +
          name +
          '"]'
        )
        ?.setAttribute(
          'aria-expanded',
          'false'
        );
      });

    hideColourPreview();

    if (returnToTop) {
      scrollConfiguratorToTop();
    }
  }

  function openPanel(name) {
    const panel =
      panels[name];

    const trigger =
      root.querySelector(
        '[data-dfb-trigger="' +
        name +
        '"]'
      );

    if (!panel || !trigger) {
      return;
    }

    const opening =
      panel.hidden;

    closePanels(
      name,
      false
    );

    panel.hidden =
      !opening;

    trigger.setAttribute(
      'aria-expanded',
      opening
        ? 'true'
        : 'false'
    );

    if (!opening) {
      scrollConfiguratorToTop();
      return;
    }

    if (name === 'size') {
      renderSizes();
    }

    if (name === 'colour') {
      renderColours();
    }

    if (name === 'storage') {
      renderStorage();
    }

    if (name === 'mattress') {
      renderMattresses();
    }

    if (name === 'headboard') {
      renderHeadboards();
    }

    scrollSectionToTop(name);
  }

  function renderSizes() {
    const items =
      productSizeOptions()
        .map(function (option) {
          return {
            option: option,
            meta: metaFor(
              option.value
            )
          };
        })
        .filter(function (item) {
          return !!item.meta;
        });

    panels.size.innerHTML = `
      <div class="dfb-size-grid">

        ${
          items.map(
            function (item) {
              return `
                <button
                  type="button"
                  class="dfb-size-choice${
                    item.option.selected
                      ? ' is-selected'
                      : ''
                  }"
                  data-value="${escapeHtml(
                    item.option.value
                  )}"
                >

                  <img
                    src="${escapeHtml(
                      item.meta.icon
                    )}"
                    alt=""
                  >

                  <strong>
                    ${escapeHtml(
                      item.meta.label
                    )}
                  </strong>

                  <span>
                    ${escapeHtml(
                      item.meta.dimensions
                    )}
                  </span>

                </button>
              `;
            }
          ).join('')
        }

      </div>
    `;

    panels.size
      .querySelectorAll(
        '.dfb-size-choice'
      )
      .forEach(function (button) {
        button.addEventListener(
          'click',
          function () {
            setConfiguredSize(
              this.dataset.value
            );

            closePanels(
              null,
              true
            );
          }
        );
      });
  }

  function renderColours() {
    const colours =
      productColourOptions();

    if (!colours.length) {
      panels.colour.innerHTML = `
        <div class="dfb-config-message">
          No colour options found.
        </div>
      `;

      return;
    }

    panels.colour.innerHTML = `
      <div class="dfb-colour-grid"></div>

      <p class="dfb-colour-note">
        <strong>Note:</strong> Fabric colours may vary slightly from the images shown due to lighting conditions and display settings.
      </p>
    `;

    const grid =
      panels.colour.querySelector(
        '.dfb-colour-grid'
      );

    colours.forEach(function (colour) {
      const button =
        document.createElement(
          'button'
        );

      button.type =
        'button';

      button.className =
        'dfb-colour-choice' +
        (
          clean(colour.value) ===
          clean(state.colour)
            ? ' is-selected'
            : ''
        );

      button.dataset.value =
        colour.value;

      button.title =
        colour.value;

      button.setAttribute(
        'aria-label',
        colour.value
      );

      const visual =
        document.createElement(
          'span'
        );

      visual.className =
        'dfb-colour-choice-visual';

      paintSwatch(
        visual,
        colour.value
      );

      button.appendChild(
        visual
      );

      button.addEventListener(
        'mouseenter',
        function () {
          showColourPreview(
            button
          );
        }
      );

      button.addEventListener(
        'mouseleave',
        hideColourPreview
      );

      button.addEventListener(
        'focus',
        function () {
          showColourPreview(
            button
          );
        }
      );

      button.addEventListener(
        'blur',
        hideColourPreview
      );

      button.addEventListener(
        'click',
        function () {
          hideColourPreview();

          setConfiguredColour(
            this.dataset.value
          );

          closePanels(
            null,
            false
          );
        }
      );

      grid.appendChild(
        button
      );
    });
  }

  function productOptionPosition(
    product,
    kind
  ) {
    const options =
      product.options || [];

    for (
      let index = 0;
      index < options.length;
      index++
    ) {
      const option =
        options[index];

      const name =
        clean(
          option.name ||
          option
        );

      if (
        kind === 'size' &&
        name.includes('size')
      ) {
        return (
          option.position ||
          index + 1
        );
      }

      if (
        kind === 'colour' &&
        (
          name.includes('colour') ||
          name.includes('color') ||
          name.includes('fabric')
        )
      ) {
        return (
          option.position ||
          index + 1
        );
      }

      if (
        kind === 'headboard' &&
        name.includes('headboard')
      ) {
        return (
          option.position ||
          index + 1
        );
      }
    }

    return 0;
  }

  function variantOption(
    variant,
    position
  ) {
    if (!position) {
      return '';
    }

    return (
      variant[
        'option' +
        position
      ] ||

      (
        variant.options
          ? variant.options[
              position - 1
            ]
          : ''
      ) ||

      ''
    );
  }

  function imageSrc(image) {
    if (!image) return '';

    if (
      typeof image ===
      'string'
    ) {
      return image;
    }

    return (
      image.src ||
      image.url ||
      ''
    );
  }

  function productImage(product) {
    if (
      !product.images ||
      !product.images.length
    ) {
      return '';
    }

    return imageSrc(
      product.images[0]
    );
  }

  function variantImage(
    product,
    variant
  ) {
    if (!variant) {
      return productImage(
        product
      );
    }

    if (
      variant.featured_image
    ) {
      const found =
        imageSrc(
          variant.featured_image
        );

      if (found) {
        return found;
      }
    }

    if (
      variant.featured_media &&
      variant.featured_media.preview_image
    ) {
      const found =
        imageSrc(
          variant.featured_media
            .preview_image
        );

      if (found) {
        return found;
      }
    }

    if (product.images) {
      const matchingImage =
        product.images.find(
          function (image) {
            if (
              !Array.isArray(
                image.variant_ids
              )
            ) {
              return false;
            }

            return image.variant_ids
              .map(String)
              .includes(
                String(
                  variant.id
                )
              );
          }
        );

      if (matchingImage) {
        return imageSrc(
          matchingImage
        );
      }
    }

    return productImage(
      product
    );
  }

  function mattressVariant(product) {
    const requiredSize =
      sizeKey(state.size);

    const sizePosition =
      productOptionPosition(
        product,
        'size'
      );

    return (
      (product.variants || [])
        .find(
          function (variant) {
            const combined = [
              variant.title,
              variant.option1,
              variant.option2,
              variant.option3
            ]
              .filter(Boolean)
              .join(' ');

            const sizeValue =
              sizePosition
                ? variantOption(
                    variant,
                    sizePosition
                  )
                : combined;

            return (
              variant.available !== false &&
              requiredSize !== '' &&
              sizeKey(sizeValue) ===
              requiredSize
            );
          }
        ) || null
    );
  }

  function headboardVariant(product) {
    const requiredSize =
      sizeKey(state.size);

    const requiredColour =
      colourKey(state.colour);

    const requiredFabric =
      fabricKey(state.colour);

    const requiredFull =
      clean(state.colour);

    const sizePosition =
      productOptionPosition(
        product,
        'size'
      );

    const colourPosition =
      productOptionPosition(
        product,
        'colour'
      );

    const candidates =
      (product.variants || [])
        .filter(
          function (variant) {
            const combined = [
              variant.title,
              variant.option1,
              variant.option2,
              variant.option3
            ]
              .filter(Boolean)
              .join(' ');

            const sizeValue =
              sizePosition
                ? variantOption(
                    variant,
                    sizePosition
                  )
                : combined;

            return (
              variant.available !== false &&
              requiredSize !== '' &&
              sizeKey(sizeValue) ===
              requiredSize
            );
          }
        );

    if (!candidates.length) {
      return null;
    }

    let match =
      candidates.find(
        function (variant) {
          const combined = [
            variant.title,
            variant.option1,
            variant.option2,
            variant.option3
          ]
            .filter(Boolean)
            .join(' ');

          const colourValue =
            colourPosition
              ? variantOption(
                  variant,
                  colourPosition
                )
              : combined;

          return (
            clean(colourValue) ===
            requiredFull
          );
        }
      );

    if (match) {
      return match;
    }

    match =
      candidates.find(
        function (variant) {
          const combined = [
            variant.title,
            variant.option1,
            variant.option2,
            variant.option3
          ]
            .filter(Boolean)
            .join(' ');

          const colourValue =
            colourPosition
              ? variantOption(
                  variant,
                  colourPosition
                )
              : combined;

          return (
            requiredColour !== '' &&
            colourKey(colourValue) ===
            requiredColour &&
            (
              !requiredFabric ||
              fabricKey(colourValue) ===
              requiredFabric
            )
          );
        }
      );

    if (match) {
      return match;
    }

    return null;
  }

  function orderedHeadboards(products) {
    const orderMap =
      new Map();

    HEADBOARD_ORDER.forEach(
      function (
        title,
        index
      ) {
        orderMap.set(
          clean(title),
          index
        );
      }
    );

    return products
      .filter(
        function (product) {
          return orderMap.has(
            clean(product.title)
          );
        }
      )
      .sort(
        function (a, b) {
          return (
            orderMap.get(
              clean(a.title)
            ) -
            orderMap.get(
              clean(b.title)
            )
          );
        }
      );
  }

  function loadCollection(kind) {
    if (state[kind]) {
      return Promise.resolve(
        state[kind]
      );
    }

    /*
     * DIVAN BEDS ONLY:
     * Show the full Mattress collection, but remove the mattresses
     * that belong to the Bed Base mattress add-on collection.
     *
     * IMPORTANT:
     * Any product/configurator that is NOT recognised as a Divan
     * keeps the original Bed Base mattress source below unchanged.
     * This protects Ottoman Bed Base Front Lift / Side Lift.
     */
    if (
      kind === 'mattresses' &&
      isDivanConfigurator()
    ) {
      return Promise.all([
        fetch('/collections/mattresses/products.json?limit=250'),
        fetch('/collections/bed-base-mattress-add-ons/products.json?limit=250')
      ])
        .then(function (responses) {
          if (!responses[0].ok) {
            throw new Error(
              'Mattress collection could not be loaded'
            );
          }

          if (!responses[1].ok) {
            throw new Error(
              'Bed Base mattress exclusion collection could not be loaded'
            );
          }

          return Promise.all([
            responses[0].json(),
            responses[1].json()
          ]);
        })
        .then(function (results) {
          const allMattresses =
            results[0].products || [];

          const bedBaseMattresses =
            results[1].products || [];

          const excludedHandles =
            new Set(
              bedBaseMattresses.map(
                function (product) {
                  return product.handle;
                }
              )
            );

          state[kind] =
            allMattresses.filter(
              function (product) {
                return !excludedHandles.has(
                  product.handle
                );
              }
            );

          return state[kind];
        });
    }

    /*
     * ORIGINAL BEHAVIOUR FOR EVERYTHING ELSE.
     * Do not alter Ottoman Bed Base Front Lift / Side Lift.
     */
    const url =
      kind === 'mattresses'
        ? '/collections/bed-base-mattress-add-ons/products.json?limit=20'
        : '/collections/bed-base-headboard-add-ons/products.json?limit=20';

    return fetch(url)
      .then(
        function (response) {
          if (!response.ok) {
            throw new Error(
              'Collection could not be loaded'
            );
          }

          return response.json();
        }
      )
      .then(
        function (data) {
          state[kind] =
            data.products || [];

          return state[kind];
        }
      );
  }

  function productTags(product) {
    const tags =
      product && product.tags
        ? product.tags
        : [];

    if (Array.isArray(tags)) {
      return tags.map(function (tag) {
        return String(tag || '').trim();
      }).filter(Boolean);
    }

    return String(tags || '')
      .split(',')
      .map(function (tag) {
        return tag.trim();
      })
      .filter(Boolean);
  }

  function firmness(product) {
    const tags =
      productTags(product);

    const match =
      tags.find(
        function (tag) {
          return clean(tag)
            .includes(
              'firmness'
            );
        }
      );

    if (!match) return '';

    return String(match)
      .replace(
        /^firmness[-:\s]*/i,
        ''
      );
  }

  const MATTRESS_FEATURE_TAGS = [
    {
      label: 'Open Coil',
      className: 'dfb-addon-pill--open-coil'
    },
    {
      label: 'Hand Tufted',
      className: 'dfb-addon-pill--hand-tufted'
    },
    {
      label: 'Memory Foam',
      className: 'dfb-addon-pill--memory-foam'
    },
    {
      label: 'Pocket Spring',
      className: 'dfb-addon-pill--pocket-spring'
    },
    {
      label: 'Natural Fillings',
      className: 'dfb-addon-pill--natural-fillings'
    },
    {
      label: 'Cool Gel',
      className: 'dfb-addon-pill--cool-gel'
    },
    {
      label: 'TENCEL',
      className: 'dfb-addon-pill--tencel'
    },
    {
      label: 'Latex Gel',
      className: 'dfb-addon-pill--latex-gel'
    },
    {
      label: 'Full Foam',
      className: 'dfb-addon-pill--full-foam'
    }
  ];

  function mattressFeatureTags(product) {
    const tags =
      productTags(product);

    return MATTRESS_FEATURE_TAGS.filter(
      function (feature) {
        return tags.some(
          function (tag) {
            return clean(tag) ===
              clean(feature.label);
          }
        );
      }
    );
  }

  function mattressPills(product) {
    const firm =
      firmness(product);

    const features =
      mattressFeatureTags(product);

    const pills = [];

    if (firm) {
      pills.push(`
        <span class="dfb-addon-pill dfb-addon-pill--firmness">
          ${escapeHtml(firm)}
        </span>
      `);
    }

    features.forEach(
      function (feature) {
        pills.push(`
          <span class="dfb-addon-pill ${feature.className}">
            ${escapeHtml(feature.label)}
          </span>
        `);
      }
    );

    if (!pills.length) {
      return '';
    }

    return `
      <div class="dfb-addon-pills">
        ${pills.join('')}
      </div>
    `;
  }

  function addonCard(
    product,
    variant,
    kind
  ) {
    const image =
      kind === 'headboard'
        ? variantImage(
            product,
            variant
          )
        : productImage(
            product
          );

    const price =
      apiPrice(
        variant.price
      );

    const mattressBadges =
      kind === 'mattress'
        ? mattressPills(product)
        : '';

    return `
      <div
        class="dfb-addon-card-wrap"
        data-handle="${escapeHtml(
          product.handle
        )}"
      >

        <div class="dfb-addon-card">

          ${
            image
              ? `
                <img
                  class="dfb-addon-thumb"
                  src="${escapeHtml(image)}"
                  alt="${escapeHtml(
                    product.title
                  )}"
                >
              `
              : ''
          }

          <div class="dfb-addon-info">

            <div class="dfb-addon-title">
              ${escapeHtml(
                product.title
              )}
            </div>

            ${
              kind === 'mattress'
                ? mattressBadges
                : ''
            }

            ${
              kind === 'headboard'
                ? `
                  <span class="dfb-addon-pill">
                    ${escapeHtml(
                      state.colour
                    )}
                  </span>
                `
                : ''
            }

            <div class="dfb-addon-price">
              ${money(price)}
            </div>

            <div class="dfb-addon-buttons">

              <button
                type="button"
                class="dfb-addon-details-button"
              >
                More details
              </button>

              <button
                type="button"
                class="dfb-addon-select"
                data-kind="${kind}"
              >
                ${
                  kind === 'mattress'
                    ? 'Add Mattress'
                    : 'Add Headboard'
                }
              </button>

            </div>

          </div>

        </div>

        <div
          class="dfb-addon-details-panel"
          hidden
        >

          ${
            image
              ? `
                <img
                  class="dfb-addon-details-image"
                  src="${escapeHtml(image)}"
                  alt="${escapeHtml(
                    product.title
                  )}"
                >
              `
              : ''
          }

          <div class="dfb-addon-details-body">
            ${product.body_html || ''}
          </div>

        </div>

      </div>
    `;
  }

  function attachAddonButtons(
    panel,
    products,
    kind
  ) {
    panel
      .querySelectorAll(
        '.dfb-addon-card-wrap'
      )
      .forEach(
        function (card) {

          const detailsButton =
            card.querySelector(
              '.dfb-addon-details-button'
            );

          const detailsPanel =
            card.querySelector(
              '.dfb-addon-details-panel'
            );

          if (
            detailsButton &&
            detailsPanel
          ) {
            detailsButton
              .addEventListener(
                'click',
                function () {
                  const opening =
                    detailsPanel.hidden;

                  detailsPanel.hidden =
                    !opening;

                  detailsButton.textContent =
                    opening
                      ? 'Hide details'
                      : 'More details';
                }
              );
          }

          const addButton =
            card.querySelector(
              '.dfb-addon-select'
            );

          if (!addButton) {
            return;
          }

          addButton.addEventListener(
            'click',
            function () {

              const product =
                products.find(
                  function (item) {
                    return (
                      item.handle ===
                      card.dataset.handle
                    );
                  }
                );

              if (!product) return;

              const variant =
                kind === 'mattress'
                  ? mattressVariant(
                      product
                    )
                  : headboardVariant(
                      product
                    );

              if (!variant) return;

              const currentPrice =
                apiPrice(
                  variant.price
                );

              const comparePrice =
                apiPrice(
                  variant.compare_at_price
                ) ||
                currentPrice;

              const selected = {
                product: product,
                variant: variant,
                title: product.title,
                price: currentPrice,
                comparePrice:
                  comparePrice,

                image:
                  kind === 'headboard'
                    ? variantImage(
                        product,
                        variant
                      )
                    : productImage(
                        product
                      )
              };

              if (
  kind === 'mattress'
) {
  state.mattress =
    selected;

  updateMattressRow();
} else {
  state.headboard =
    selected;

  updateHeadboardRow();
}

updateTotal();

/*
 * MOBILE:
 * Keep the existing configurator scroll behaviour.
 */
if (isMobile()) {
  closePanels(
    null,
    true
  );
} else {
  /*
   * DESKTOP:
   * Close the accordion without allowing
   * closePanels to scroll the page down.
   */
  closePanels(
    null,
    false
  );

  /*
   * After selecting a HEADBOARD only,
   * return to the top of the product page.
   */
  if (kind === 'headboard') {
    setTimeout(function () {
      const productSection =
        root.closest('.shopify-section');

      if (!productSection) return;

      const top =
        productSection.getBoundingClientRect().top +
        window.pageYOffset;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    }, 100);
  }
}
            }
          );
        }
      );
  }

  function renderMattresses() {
    panels.mattress.innerHTML = `
      <div class="dfb-config-message">
        Loading mattresses...
      </div>
    `;

    loadCollection(
      'mattresses'
    )
      .then(
        function (products) {

          const html =
            products
              .map(
                function (product) {
                  const variant =
                    mattressVariant(
                      product
                    );

                  return variant
                    ? addonCard(
                        product,
                        variant,
                        'mattress'
                      )
                    : '';
                }
              )
              .filter(Boolean)
              .join('');

          panels.mattress.innerHTML =
            html ||
            `
              <div class="dfb-config-message">
                No mattresses found for this size.
              </div>
            `;

          attachAddonButtons(
            panels.mattress,
            products,
            'mattress'
          );
        }
      )
      .catch(
        function () {
          panels.mattress.innerHTML = `
            <div class="dfb-config-message">
              Could not load mattresses.
            </div>
          `;
        }
      );
  }

  function isDivanConfigurator() {
    return hasStorageConfigurator() && !!state.headboardPosition;
  }

  function divanHeadboardOptions() {
    if (!isDivanConfigurator()) return [];

    return baseOptionValues(state.headboardPosition)
      .map(function (value) {
        const text = clean(value);

        return {
          value: value,
          isFloorStanding:
            text.includes('54') ||
            text.includes('floor standing'),
          isFree:
            text.includes('26') ||
            text.includes('free')
        };
      })
      .filter(function (item) {
        return item.isFloorStanding || item.isFree;
      });
  }

  function divanHeadboardVariant(optionValue) {
    if (!state.baseProduct || !state.headboardPosition) return null;

    const wanted = state.optionValues.slice();
    wanted[state.sizePosition - 1] = state.size;
    if (state.colourPosition) wanted[state.colourPosition - 1] = state.colour;
    wanted[state.headboardPosition - 1] = optionValue;

    const matches = state.baseProduct.variants.filter(function (variant) {
      return wanted.every(function (value, index) {
        return variantOption(variant, index + 1) === value;
      });
    });

    return matches.find(function (variant) {
      return variant.available;
    }) || matches[0] || null;
  }

  function divanHeadboardUpgradePrice() {
    const options = divanHeadboardOptions();
    const free = options.find(function (item) { return item.isFree; });
    const floor = options.find(function (item) { return item.isFloorStanding; });

    if (!free || !floor) return 0;

    const freeVariant = divanHeadboardVariant(free.value);
    const floorVariant = divanHeadboardVariant(floor.value);

    if (!freeVariant || !floorVariant) return 0;

    // Shopify's product .js endpoint returns variant prices in pence.
    // Convert both matching Divan variants to pounds before calculating
    // the 54" Floor Standing Headboard upgrade.
    const freePrice =
      Number(freeVariant.price || 0) / 100;

    const floorPrice =
      Number(floorVariant.price || 0) / 100;

    return Math.max(
      0,
      floorPrice - freePrice
    );
  }

  function selectDivanHeadboard(optionValue) {
    if (!isDivanConfigurator() || cartBusy) return;

    state.divanHeadboard = optionValue;
    state.headboard = null;
    state.optionValues[state.headboardPosition - 1] = optionValue;

    resetAddedButtonState();
    resolveBaseVariant();
    syncNativeVariantPicker(state.headboardPosition);
    updateConfiguredMedia();
    updateHeadboardRow();
    updateTotal();

    closePanels(
      null,
      isMobile()
    );
  }

  function renderDivanHeadboards() {
    const options = divanHeadboardOptions();
    const free = options.find(function (item) { return item.isFree; });
    const floor = options.find(function (item) { return item.isFloorStanding; });

    if (!free || !floor) {
      panels.headboard.innerHTML = `
        <div class="dfb-config-message">
          Headboard options could not be loaded.
        </div>
      `;
      return;
    }

    const upgrade = divanHeadboardUpgradePrice();

    panels.headboard.innerHTML = `
      <div class="dfb-storage-grid">
        <button
          type="button"
          class="dfb-storage-choice${state.divanHeadboard === free.value ? ' is-selected' : ''}"
          data-divan-headboard="${escapeHtml(free.value)}"
        >
          <strong>Free 26&quot; Headboard</strong>
          <span>Included</span>
        </button>

        <button
          type="button"
          class="dfb-storage-choice${state.divanHeadboard === floor.value ? ' is-selected' : ''}"
          data-divan-headboard="${escapeHtml(floor.value)}"
        >
          <strong>54&quot; Floor Standing Headboard</strong>
          <span>${upgrade > 0 ? '+' + money(upgrade) : 'Included'}</span>
        </button>
      </div>
    `;

    panels.headboard
      .querySelectorAll('[data-divan-headboard]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          selectDivanHeadboard(this.dataset.divanHeadboard);
        });
      });
  }

  function renderHeadboards() {
    if (isDivanConfigurator()) {
      renderDivanHeadboards();
      return;
    }

    panels.headboard.innerHTML = `
      <div class="dfb-config-message">
        Loading headboards...
      </div>
    `;

    loadCollection(
      'headboards'
    )
      .then(
        function (products) {

          const ordered =
            orderedHeadboards(
              products
            );

          if (!ordered.length) {
            panels.headboard.innerHTML = `
              <div class="dfb-config-message">
                No headboards are currently available.
              </div>
            `;

            return;
          }

          const html =
            ordered
              .map(
                function (product) {

                  const variant =
                    headboardVariant(
                      product
                    );

                  return variant
                    ? addonCard(
                        product,
                        variant,
                        'headboard'
                      )
                    : '';
                }
              )
              .filter(Boolean)
              .join('');

          panels.headboard.innerHTML =
            html ||
            `
              <div class="dfb-config-message">
                No matching headboards were found
                for this bed size and colour.
              </div>
            `;

          attachAddonButtons(
            panels.headboard,
            ordered,
            'headboard'
          );
        }
      )
      .catch(
        function () {
          panels.headboard.innerHTML = `
            <div class="dfb-config-message">
              Could not load headboards.
            </div>
          `;
        }
      );
  }

  function updateMattressRow() {
    const label =
      document.getElementById(
        'dfb-mattress-label'
      );

    const value =
      document.getElementById(
        'dfb-mattress-value'
      );

    const price =
      document.getElementById(
        'dfb-mattress-price'
      );

    const actions =
      document.getElementById(
        'dfb-mattress-actions'
      );

    const chevron =
      document.getElementById(
        'dfb-mattress-chevron'
      );

    if (
      !label ||
      !value ||
      !price ||
      !actions ||
      !chevron
    ) {
      return;
    }

    if (state.mattress) {
      label.hidden =
        true;

      value.textContent =
        state.mattress.title;

      price.hidden =
        false;

      price.textContent =
        money(
          state.mattress.price
        );

      actions.hidden =
        false;

      chevron.hidden =
        true;
    } else {
      label.hidden =
        false;

      label.textContent =
        'Choose Mattress';

      value.textContent =
        'Save an extra 20%';

      price.hidden =
        true;

      price.textContent =
        '';

      actions.hidden =
        true;

      chevron.hidden =
        false;
    }
  }

  function updateHeadboardRow() {
    const label =
      document.getElementById(
        'dfb-headboard-label'
      );

    const value =
      document.getElementById(
        'dfb-headboard-value'
      );

    const price =
      document.getElementById(
        'dfb-headboard-price'
      );

    const actions =
      document.getElementById(
        'dfb-headboard-actions'
      );

    const chevron =
      document.getElementById(
        'dfb-headboard-chevron'
      );

    if (
      !label ||
      !value ||
      !price ||
      !actions ||
      !chevron
    ) {
      return;
    }

    if (isDivanConfigurator()) {
      const options = divanHeadboardOptions();
      const selected = options.find(function (item) {
        return item.value === state.divanHeadboard;
      });
      const upgrade = divanHeadboardUpgradePrice();

      label.hidden = false;
      label.textContent = 'Choose Headboard';

      if (selected && selected.isFloorStanding) {
        value.textContent =
          '54" Floor Standing Headboard' +
          (upgrade > 0 ? ' +' + money(upgrade) : '');
      } else {
        value.textContent = 'Free 26" Headboard';
      }

      price.hidden = true;
      price.textContent = '';
      actions.hidden = true;
      chevron.hidden = false;
      return;
    }

    if (state.headboard) {
      label.hidden =
        true;

      value.textContent =
        state.headboard.title;

      price.hidden =
        false;

      price.textContent =
        money(
          state.headboard.price
        );

      actions.hidden =
        false;

      chevron.hidden =
        true;
    } else {
      label.hidden =
        false;

      label.textContent =
        'Choose Headboard';

      value.textContent =
        'Save an extra 20%';

      price.hidden =
        true;

      price.textContent =
        '';

      actions.hidden =
        true;

      chevron.hidden =
        false;
    }
  }

  function revalidate() {
    if (
      state.mattress &&
      state.mattress.product
    ) {
      const variant =
        mattressVariant(
          state.mattress.product
        );

      if (variant) {
        const currentPrice =
          apiPrice(
            variant.price
          );

        state.mattress.variant =
          variant;

        state.mattress.price =
          currentPrice;

        state.mattress.comparePrice =
          apiPrice(
            variant.compare_at_price
          ) ||
          currentPrice;
      } else {
        state.mattress =
          null;
      }

      updateMattressRow();
    }

    if (
      !isDivanConfigurator() &&
      state.headboard &&
      state.headboard.product
    ) {
      const variant =
        headboardVariant(
          state.headboard.product
        );

      if (variant) {
        const currentPrice =
          apiPrice(
            variant.price
          );

        state.headboard.variant =
          variant;

        state.headboard.price =
          currentPrice;

        state.headboard.comparePrice =
          apiPrice(
            variant.compare_at_price
          ) ||
          currentPrice;

        state.headboard.image =
          variantImage(
            state.headboard.product,
            variant
          );
      } else {
        state.headboard =
          null;
      }

      updateHeadboardRow();
    }
  }

  function currentVariantId() {
    return state.baseVariant ? String(state.baseVariant.id) : '';
  }

  function updateBasePrice() {
    const variant = state.baseVariant;
    state.basePrice = variant ? Number(variant.price || 0) / 100 : 0;
    state.baseComparePrice = variant
      ? Math.max(state.basePrice, Number(variant.compare_at_price || 0) / 100)
      : 0;
  }

  let cachedSellingPrice = null;

  function sellingPriceElement() {
    if (cachedSellingPrice?.isConnected) return cachedSellingPrice;
    const host =
      priceHost();

    if (!host) return null;

    return (
      Array.from(
        host.querySelectorAll(
          'span,div'
        )
      )
      .find(
        function (element) {
          const text =
            element.textContent.trim();

          return (
            /^£\s?[\d,.]+$/
              .test(text) &&

            !element.closest(
              's,del'
            ) &&

            !getComputedStyle(
              element
            )
            .textDecorationLine
            .includes(
              'line-through'
            )
          );
        }
      ) || null
    );
  }

  function comparePriceElement() {
    const host =
      priceHost();

    if (!host) return null;

    const direct =
      host.querySelector(
        's,del,' +
        '[class*="compare-at"],' +
        '[class*="compare_at"],' +
        '[class*="compare"]'
      );

    if (direct) {
      const nested =
        Array.from(
          direct.querySelectorAll(
            'span,div'
          )
        )
        .find(
          function (element) {
            return (
              /^£\s?[\d,.]+$/
                .test(
                  element
                    .textContent
                    .trim()
                )
            );
          }
        );

      return nested || direct;
    }

    return (
      Array.from(
        host.querySelectorAll(
          'span,div'
        )
      )
      .find(
        function (element) {
          const text =
            element
              .textContent
              .trim();

          return (
            /^£\s?[\d,.]+$/
              .test(text) &&

            getComputedStyle(
              element
            )
            .textDecorationLine
            .includes(
              'line-through'
            )
          );
        }
      ) || null
    );
  }

  function savingElement() {
    const host = priceHost();
    const selling = sellingPriceElement();
    const compare = comparePriceElement();
    if (!host || !selling) return null;

    // Keep the saving beside the price, outside the struck-through element.
    let row = selling.parentElement;
    while (compare && row !== host && !row.contains(compare)) {
      row = row.parentElement;
    }
    const priceBranch = function (element) {
      while (element.parentElement && element.parentElement !== row) {
        element = element.parentElement;
      }
      return element;
    };
    const anchor = priceBranch(compare || selling);
    let save = host.querySelector('[data-dfb-price-saving], .price-save-badge');
    if (!save) {
      save = document.createElement('span');
    }
    save.classList.add('dfb-total-save', 'price-save-badge');
    save.dataset.dfbPriceSaving = 'true';

    // Themes may already render a saving, including just outside product-price.
    // Match only standalone saving labels; never remove a price or other content.
    const scope = host;
    Array.from(scope.querySelectorAll('*')).reverse().forEach(function (element) {
      if (element === save || element.contains(save) || element.contains(host) ||
          element.contains(selling) || (compare && element.contains(compare))) return;
      if (/^Save\s+£\s*[\d,.]+$/i.test(element.textContent.trim())) {
        element.remove();
      }
    });
    if (anchor.nextElementSibling !== save) anchor.after(save);

    // A dedicated inline group keeps the three amounts on one baseline without
    // changing tax text, review stars, or the mobile sticky price container.
    let group = selling.closest('[data-dfb-price-line]');
    if (!group) {
      group = document.createElement('span');
      group.dataset.dfbPriceLine = 'true';
      const sellingBranch = priceBranch(selling);
      row.insertBefore(group, sellingBranch);
      group.appendChild(sellingBranch);
      if (anchor !== sellingBranch) group.appendChild(anchor);
      group.appendChild(save);
    }
    save.style.setProperty('font-size', '15px', 'important');
    return save;
  }


  function selectedServiceTotal() {
    const services =
      state.services || {};

    return Object.keys(services)
      .reduce(
        function (total, key) {

          const service =
            services[key];

          if (
            !service ||
            service.selected !== true
          ) {
            return total;
          }

          return total +
            apiPrice(
              service.price
            );
        },
        0
      );
  }

  function setServiceSelection(
    serviceName,
    selected,
    price
  ) {
    if (
      !serviceName ||
      !state.services ||
      !state.services[serviceName]
    ) {
      return;
    }

    state.services[
      serviceName
    ].selected =
      selected === true;

    if (
      price !== undefined &&
      price !== null &&
      price !== ''
    ) {
      state.services[
        serviceName
      ].price =
        apiPrice(price);
    }

    updateTotal();
  }

  function scheduleConfiguredPriceRestore() {
    [
      0,
      80,
      220,
      450,
      800,
      1400
    ].forEach(
      function (delay) {

        window.setTimeout(
          function () {

            if (!root.isConnected) {
              return;
            }

            // Horizon can replace the complete product-price element
            // during cart refreshes, so force these references to be
            // rediscovered before applying the configured total again.
            cachedPriceHost =
              null;

            cachedSellingPrice =
              null;

            updateTotal();

            enableExistingStickyPrice();
          },
          delay
        );
      }
    );
  }


  function updateTotal() {
    updateBasePrice();

    const serviceTotal =
      selectedServiceTotal();

    const currentTotal =
      state.basePrice +

      (
        hasStorageConfigurator() && state.storage
          ? state.storage.price
          : 0
      ) +

      (
        state.mattress
          ? state.mattress.price
          : 0
      ) +

      (
        state.headboard
          ? state.headboard.price
          : 0
      ) +

      serviceTotal;

    const compareTotal =
      state.baseComparePrice +

      (
        hasStorageConfigurator() && state.storage
          ? state.storage.price
          : 0
      ) +

      (
        state.mattress
          ? (
              state.mattress
                .comparePrice ||
              state.mattress.price
            )
          : 0
      ) +

      (
        state.headboard
          ? (
              state.headboard
                .comparePrice ||
              state.headboard.price
            )
          : 0
      ) +

      // Services are not discounted here, so add the same service
      // amount to both selling and compare totals. This means the
      // displayed "Save £..." amount stays based only on genuine
      // compare-at savings on the bed/mattress/headboard.
      serviceTotal;

    const saving =
      Math.max(
        0,
        compareTotal -
        currentTotal
      );

    const selling =
      sellingPriceElement();
    if (selling) cachedSellingPrice = selling;
    if (!cachedPriceHost) cachedPriceHost = priceHost();

    const compare =
      comparePriceElement();

    const save =
      savingElement();

    if (
      selling
    ) {
      selling.textContent =
        state.baseVariant ? money(currentTotal) : 'Unavailable';
    }

    if (compare) {
      if (
        compareTotal >
        currentTotal
      ) {
        compare.textContent =
          money(compareTotal);

        compare.style.display =
          '';
      } else {
        compare.style.display =
          'none';
      }
    }

    if (save) {
      if (saving > 0) {
        save.textContent =
          'Save ' +
          money(saving);

        save.style.display =
          '';
      } else {
        save.textContent =
          '';

        save.style.display =
          'none';
      }
    }

    enableExistingStickyPrice();
  }

  function loadBase() {
    updateBaseAvailability();
    return fetch(location.pathname.replace(/\/$/, '') + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('The bed product could not be loaded.');
        return response.json();
      })
      .then(function (product) {
        if (!Array.isArray(product.variants) || !product.variants.length) {
          throw new Error('No bed variants were returned.');
        }
        state.baseProduct = product;
        state.sizePosition = productOptionPosition(product, 'size');
        state.colourPosition = productOptionPosition(product, 'colour');
        state.headboardPosition = productOptionPosition(product, 'headboard');
        if (!state.sizePosition) throw new Error('The bed product has no Size option.');

        const available = product.variants.filter(function (variant) { return variant.available; });
        const candidates = available.length ? available : product.variants;
        const single = function (variant) {
          return sizeKey(variantOption(variant, state.sizePosition)) === 'single';
        };
        const cream = function (variant) {
          const value = clean(variantOption(variant, state.colourPosition));
          return value.includes('cream') && value.includes('plush');
        };
        const preferred = product.variants.filter(function (variant) {
          return single(variant) && clean(variantOption(variant, state.colourPosition)) === clean('Cream Plush Velvet');
        });
        const initial = preferred.find(function (variant) { return variant.available; }) || preferred[0] ||
          candidates.find(function (variant) { return single(variant) && cream(variant); }) ||
          candidates.find(single) || candidates.find(cream) || candidates[0];

        state.optionValues = product.options.map(function (option, index) {
          return variantOption(initial, index + 1);
        });
        state.size = variantOption(initial, state.sizePosition);
        state.colour = variantOption(initial, state.colourPosition);

        if (state.headboardPosition) {
          const headboardOptions = baseOptionValues(state.headboardPosition);
          const freeHeadboard = headboardOptions.find(function (value) {
            const text = clean(value);
            return text.includes('26') || text.includes('free');
          });

          state.divanHeadboard =
            freeHeadboard ||
            variantOption(initial, state.headboardPosition);

          state.optionValues[state.headboardPosition - 1] =
            state.divanHeadboard;
        }

        state.ready = true;
        resolveBaseVariant();
        updateConfiguredMedia();
        resetStorageIfInvalid();
        updateStorageRow();
        updateMattressRow();
        updateHeadboardRow();
        renderSizes();
        renderColours();
        sync(false);
      })
      .catch(function (error) {
        console.error('DFB product loading error:', error);
        state.ready = false;
        updateBaseAvailability();
        const message = root.querySelector('.dfb-base-status');
        if (message) message.textContent = error.message + ' Please reload the page.';
      });
  }

  function sync(
    revalidateAddons
  ) {
    updateSizeRow();
    updateColourRow();
    resetStorageIfInvalid();
    updateStorageRow();
    updateBaseAvailability();

    if (
      revalidateAddons
    ) {
      revalidate();
    }

    if (
      panels.storage &&
      !panels.storage.hidden
    ) {
      renderStorage();
    }

    if (
      panels.headboard &&
      !panels.headboard.hidden
    ) {
      renderHeadboards();
    }

    if (
      panels.mattress &&
      !panels.mattress.hidden
    ) {
      renderMattresses();
    }

    updateTotal();
    enableExistingStickyPrice();
  }

  root
    .querySelectorAll(
      '[data-dfb-trigger]'
    )
    .forEach(
      function (button) {
        button.addEventListener(
          'click',
          function (event) {
            event.preventDefault();

            openPanel(
              button.dataset
                .dfbTrigger
            );
          }
        );
      }
    );

  root
    .querySelectorAll(
      '[data-dfb-change]'
    )
    .forEach(
      function (button) {
        button.addEventListener(
          'click',
          function (event) {
            event.preventDefault();

            openPanel(
              this.dataset
                .dfbChange
            );
          }
        );
      }
    );

  root
    .querySelectorAll(
      '[data-dfb-remove]'
    )
    .forEach(
      function (button) {
        button.addEventListener(
          'click',
          function (event) {
            event.preventDefault();

            if (
              this.dataset
                .dfbRemove ===
              'mattress'
            ) {
              state.mattress =
                null;

              updateMattressRow();
            } else {
              state.headboard =
                null;

              updateHeadboardRow();
            }

            updateTotal();
            scrollConfiguratorToTop();
          }
        );
      }
    );

  const customStyle =
    document.createElement(
      'style'
    );

  customStyle.textContent = `

    .dfb-native-picker-hidden {

      position:absolute !important;

      width:1px !important;
      height:1px !important;

      overflow:hidden !important;

      clip:rect(0 0 0 0) !important;

      clip-path:inset(50%) !important;

      opacity:0 !important;

      pointer-events:none !important;

      margin:0 !important;
      padding:0 !important;

    }


    [data-dfb-price-line] {
      display:inline-flex !important;
      align-items:baseline !important;
      flex-wrap:nowrap !important;
      gap:8px !important;
      white-space:nowrap !important;
    }

    [data-dfb-price-line] > * {
      flex:0 0 auto !important;
      width:auto !important;
    }

    .dfb-total-save {

      margin:0 !important;
      font-size:15px !important;
      line-height:1 !important;
      text-decoration:none !important;

      font-weight:700 !important;

      color:#3f3f3f !important;

      white-space:nowrap !important;

    }


    .dfb-addon-pills {
      display:flex !important;
      flex-wrap:nowrap !important;
      align-items:center !important;
      gap:5px !important;
      margin:0 !important;

      /*
       * Keep every mattress card the same height.
       * Extra feature pills stay on one line and can scroll sideways
       * instead of wrapping onto another row.
       */
      overflow-x:auto !important;
      overflow-y:hidden !important;
      max-width:100% !important;
      scrollbar-width:none !important;
      -ms-overflow-style:none !important;
      -webkit-overflow-scrolling:touch !important;
    }

    .dfb-addon-pills::-webkit-scrollbar {
      display:none !important;
    }

    .dfb-addon-pills .dfb-addon-pill {
      flex:0 0 auto !important;
      white-space:nowrap !important;
    }

    .dfb-addon-pill--firmness {
      border-color:#8fc5ac !important;
      background:#e4f5ec !important;
      color:#345d4c !important;
    }

    .dfb-addon-pill--open-coil {
      border-color:#94b8e8 !important;
      background:#eaf3ff !important;
      color:#365a85 !important;
    }

    .dfb-addon-pill--hand-tufted {
      border-color:#d6b56c !important;
      background:#fff3d9 !important;
      color:#755a1e !important;
    }

    .dfb-addon-pill--memory-foam {
      border-color:#b7a0e0 !important;
      background:#f2ecff !important;
      color:#5e478a !important;
    }

    .dfb-addon-pill--pocket-spring {
      border-color:#d8a078 !important;
      background:#fff0e7 !important;
      color:#7a4c2f !important;
    }

    .dfb-addon-pill--natural-fillings {
      border-color:#8ebd96 !important;
      background:#eaf7ec !important;
      color:#3d6b45 !important;
    }

    .dfb-addon-pill--cool-gel {
      border-color:#7dbfd3 !important;
      background:#e7f8fc !important;
      color:#2f6573 !important;
    }

    .dfb-addon-pill--tencel {
      border-color:#9bb99c !important;
      background:#eef7ee !important;
      color:#466747 !important;
    }

    .dfb-addon-pill--latex-gel {
      border-color:#d2a3be !important;
      background:#fbeef5 !important;
      color:#7b4d67 !important;
    }

    .dfb-addon-pill--full-foam {
      border-color:#aaa9c8 !important;
      background:#f0f0f8 !important;
      color:#55546f !important;
    }


    .dfb-colour-note {

      margin:16px 12px 14px !important;

      color:#3f3f3f !important;

      font-size:13px !important;

      line-height:1.4 !important;

    }


    .dfb-existing-price-sticky {

      position:relative;

    }


    @media screen and (max-width:749px) {

      product-price.dfb-existing-price-sticky {

        position:sticky !important;

        top:0 !important;

        z-index:999 !important;

        background:#ffffff !important;

        padding-top:8px !important;

        padding-bottom:8px !important;

        box-shadow:
          0 5px 10px
          rgba(0,0,0,0.06);

      }

    }

  `;

  document.head.appendChild(
    customStyle
  );

  if (variantRoot) {
    variantRoot.classList.add(
      'dfb-native-picker-hidden'
    );
  }

  function isMainBedForm(form) {
    if (!form || form.matches('.addon-form, [data-dfb-addon-form]') || form.closest('.addon-wrapper, [data-dfb-addons]')) {
      return false;
    }
    return mainBedForms().includes(form);
  }

  function formQuantity(form) {
    const input =
      form.querySelector(
        '[name="quantity"]'
      );

    const quantity =
      parseInt(
        input
          ? input.value
          : '1',
        10
      );

    return (
      Number.isFinite(
        quantity
      ) &&
      quantity > 0
    )
      ? quantity
      : 1;
  }

  function formProperties(form) {
    const properties = {};

    form
      .querySelectorAll(
        '[name^="properties["]'
      )
      .forEach(
        function (input) {

          if (
            (
              input.type ===
              'checkbox' ||
              input.type ===
              'radio'
            ) &&
            !input.checked
          ) {
            return;
          }

          if (!input.value) {
            return;
          }

          const match =
            input.name.match(
              /^properties\[(.*)\]$/
            );

          if (!match) {
            return;
          }

          properties[
            match[1]
          ] =
            input.value;
        }
      );

    return properties;
  }

  function formSellingPlan(form) {
    const field =
      form.querySelector(
        '[name="selling_plan"]'
      );

    if (
      !field ||
      !field.value
    ) {
      return null;
    }

    return field.value;
  }

  function buildCartItems(form) {
    resolveBaseVariant();
    if (!state.ready || !state.baseVariant?.available) return [];
    const idInput =
      form.querySelector(
        '[name="id"]'
      );

    if (!idInput) {
      return [];
    }

    const quantity =
      formQuantity(form);

    const properties =
      formProperties(form);

    const sellingPlan =
      formSellingPlan(form);

    const bedItem = {
      id: Number(
        idInput.value
      ),
      quantity: quantity
    };

    if (
      Object.keys(
        properties
      ).length
    ) {
      bedItem.properties =
        properties;
    }

    if (sellingPlan) {
      bedItem.selling_plan =
        sellingPlan;
    }

    const items = [
      bedItem
    ];

    if (
      hasStorageConfigurator() &&
      state.storage &&
      state.storage.id
    ) {
      items.push({
        id: Number(state.storage.id),
        quantity: quantity
      });
    }

    if (
      state.mattress &&
      state.mattress.variant &&
      state.mattress.variant.id
    ) {
      items.push({
        id: Number(
          state.mattress
            .variant.id
        ),
        quantity: quantity
      });
    }

    if (
      !isDivanConfigurator() &&
      state.headboard &&
      state.headboard.variant &&
      state.headboard.variant.id
    ) {
      items.push({
        id: Number(
          state.headboard
            .variant.id
        ),
        quantity: quantity
      });
    }

    return items;
  }

  function isBuyNowButton(button) {
    if (!button) {
      return false;
    }

    const text =
      clean(
        button.textContent ||
        button.value ||
        ''
      );

    const name =
      clean(
        button.getAttribute(
          'name'
        ) || ''
      );

    if (
      name ===
      'checkout'
    ) {
      return true;
    }

    if (
      text ===
      'buy now' ||
      text.includes(
        'buy now'
      )
    ) {
      return true;
    }

    if (
      button.closest(
        '.shopify-payment-button'
      )
    ) {
      return true;
    }

    return false;
  }

  function setButtonBusy(
    button,
    busy
  ) {
    if (!button) return;

    if (busy) {
      if (
        !button.dataset
          .dfbOriginalText
      ) {
        button.dataset
          .dfbOriginalText =
          button.textContent;
      }

      button.disabled =
        true;

      button.textContent =
        'Adding...';
    } else {
      button.disabled =
        false;

      if (
        button.dataset
          .dfbOriginalText
      ) {
        button.textContent =
          button.dataset
            .dfbOriginalText;
      }
    }
  }

  function setAddedButton(button) {
    if (!button) return;

    button.disabled =
      false;

    button.dataset.dfbAdded =
      'true';

    button.textContent =
      'Added - View basket';
  }

  function resetAddedButtonState() {
    document
      .querySelectorAll(
        '[data-dfb-added="true"]'
      )
      .forEach(
        function (button) {

          button.dataset.dfbAdded =
            'false';

          if (
            button.dataset
              .dfbOriginalText
          ) {
            button.textContent =
              button.dataset
                .dfbOriginalText;
          }
        }
      );
  }

  async function addConfiguredBed(
    form,
    goToCheckout,
    clickedButton
  ) {
    if (cartBusy) return;
    if (!state.ready || !state.baseVariant?.available) {
      alert('Please select an available bed size and colour.');
      return;
    }
    if (form.reportValidity && !form.reportValidity()) return;

    const items =
      buildCartItems(form);

    if (!items.length) {
      return;
    }

    cartBusy =
      true;

    setButtonBusy(
      clickedButton,
      true
    );

    try {
      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify({
                items: items
              })
          }
        );

      if (!response.ok) {
        const errorData =
          await response
            .json()
            .catch(
              function () {
                return {};
              }
            );

        throw new Error(
          errorData.description ||
          errorData.message ||
          'Could not add configuration to basket.'
        );
      }

      if (goToCheckout) {
        window.location.href =
          '/checkout';

        return;
      }

      cartBusy =
        false;

      setAddedButton(
        clickedButton
      );

      /*
        Shopify has already confirmed the add when the response
        headers arrive. Do not wait for response.json(), and do not
        fire three separate refresh events. One refresh is enough to
        update the Horizon cart count/drawer without starting several
        overlapping refreshes.
      */
      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true
          }
        )
      );
    }

    catch (error) {
      console.error(
        'DFB configured cart error:',
        error
      );

      cartBusy =
        false;

      setButtonBusy(
        clickedButton,
        false
      );

      alert(
        error.message ||
        'Sorry, the configured bed could not be added to your basket.'
      );
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      if (!root.isConnected) return;

      const form =
        event.target;

      // The delivery-service forms are independent add-ons. Leave their
      // submit event for the add-on handler in Custom Liquid.
      if (form.matches('.addon-form, [data-dfb-addon-form]') || form.closest('.addon-wrapper, [data-dfb-addons]')) {
        return;
      }

      if (
        !isMainBedForm(
          form
        )
      ) {
        return;
      }

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

      const submitter =
        event.submitter ||

        form.querySelector(
          'button[type="submit"],' +
          'input[type="submit"]'
        );

      if (
        submitter &&
        submitter.dataset
          .dfbAdded ===
        'true'
      ) {
        window.location.href =
          '/cart';

        return;
      }

      const goToCheckout =
        isBuyNowButton(
          submitter
        );

      addConfiguredBed(
        form,
        goToCheckout,
        submitter
      );
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!root.isConnected) return;

      const button =
        event.target.closest(
          'button,' +
          'input[type="submit"],' +
          '[role="button"]'
        );

      if (!button) return;

      // Do not intercept Build & Install / Remove & Recycle buttons.
      if (button.closest('.addon-form, .addon-wrapper, [data-dfb-addon-form], [data-dfb-addons]')) {
        return;
      }

      if (
        button.dataset &&
        button.dataset.dfbAdded ===
        'true'
      ) {
        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();

        window.location.href =
          '/cart';

        return;
      }

      const isCheckout = isBuyNowButton(button);
      if (!isCheckout && button.type !== 'submit') return;

      const form = button.form || button.closest('form');

      if (
        !isMainBedForm(
          form
        )
      ) {
        return;
      }

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

      addConfiguredBed(
        form,
        isCheckout,
        button
      );
    },
    true
  );

  root.addEventListener(
    'click',
    function (event) {

      const control =
        event.target.closest(
          '.dfb-size-choice,' +
          '.dfb-colour-choice,' +
          '.dfb-storage-choice,' +
          '.dfb-addon-select,' +
          '[data-dfb-remove]'
        );

      if (control) {
        resetAddedButtonState();
      }
    }
  );

  // Load data first, then choose the default and render; no timing-dependent picker clicks.
  loadBase();

  document.addEventListener('change', function (event) {
    if (!root.isConnected) return;
    if (isMainBedForm(event.target.form) && event.target.name !== 'id') {
      resetAddedButtonState();
    }
  });

  // Keep the configuration stable while its basket request is in progress.
  root.addEventListener('click', function (event) {
    if (cartBusy) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Optional Cards tells the configurator whenever Build & Install
  // or Remove & Recycle is added/removed.
  window.addEventListener(
    'dfb:service-updated',
    function (event) {
      if (!root.isConnected) {
        return;
      }

      const detail =
        event.detail || {};

      setServiceSelection(
        detail.service,
        detail.selected === true,
        detail.price
      );

      // The service handler also refreshes Horizon's cart UI.
      // Re-apply the configured total after that DOM refresh.
      scheduleConfiguredPriceRestore();
    }
  );


  // Horizon can redraw product-price after a cart refresh. Reapply
  // the configured total several times while that async redraw settles.
  document.addEventListener(
    'cart:refresh',
    function () {
      if (!root.isConnected) return;
      scheduleConfiguredPriceRestore();
    }
  );

  document.addEventListener(
    'cart:update',
    function () {
      if (!root.isConnected) return;
      scheduleConfiguredPriceRestore();
    }
  );

  window.addEventListener(
    'cart:refresh',
    function () {
      if (!root.isConnected) return;
      scheduleConfiguredPriceRestore();
    }
  );


  // Small public hook for the Optional Cards block.
  // It may either dispatch dfb:service-updated or call this directly.
  window.DFBConfiguratorServices = {
    set: function (
      serviceName,
      selected,
      price
    ) {
      setServiceSelection(
        serviceName,
        selected === true,
        price
      );

      scheduleConfiguredPriceRestore();
    },

    refreshPrice:
      scheduleConfiguredPriceRestore
  };


  window.addEventListener(
    'resize',
    function () {
      if (!root.isConnected) return;
      enableExistingStickyPrice();
    }
  );
  }

  // Theme assets may arrive after DOMContentLoaded, and the theme editor can
  // insert the Custom Liquid section without loading the entire page again.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDFBBedConfigurator, { once: true });
  } else {
    initializeDFBBedConfigurator();
  }

  document.addEventListener('shopify:section:load', initializeDFBBedConfigurator);

  let initializationQueued = false;
  const sectionObserver = new MutationObserver(function () {
    const root = document.getElementById('dfb-bed-configurator');
    if (!root || root.dataset.dfbInitialized || initializationQueued) return;
    initializationQueued = true;
    queueMicrotask(function () {
      initializationQueued = false;
      initializeDFBBedConfigurator();
    });
  });
  sectionObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
